
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { CaseFormData } from "../CaseForm";

interface IdentificationFieldsProps {
  form: UseFormReturn<CaseFormData>;
  showOrgNumber: boolean;
  templateType: string;
}

export function IdentificationFields({ form, showOrgNumber, templateType }: IdentificationFieldsProps) {
  return (
    <div className="space-y-4">
      {showOrgNumber && (
        <FormField
          control={form.control}
          name="org_number"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="org_number" className="text-gray-900">
                Organisasjonsnummer
              </FormLabel>
              <FormControl>
                <Input 
                  id="org_number"
                  placeholder="Skriv inn organisasjonsnummer" 
                  {...field} 
                  type="text"
                  pattern="[0-9]*"
                  autoComplete="organization"
                  inputMode="numeric"
                  name="org_number"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}

      {templateType === "nav" && (
        <FormField
          control={form.control}
          name="person_id"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="person_id" className="text-gray-900">
                Fødselsnummer
              </FormLabel>
              <FormControl>
                <Input 
                  id="person_id"
                  placeholder="Skriv inn fødselsnummer" 
                  {...field} 
                  type="text"
                  pattern="[0-9]*"
                  autoComplete="off"
                  inputMode="numeric"
                  name="person_id"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}
